import React from 'react';

import { Action } from './action';
import { UpsellState, initialState } from './state';

export const UpsellContext = React.createContext<{
  state: UpsellState;
  dispatch: React.Dispatch<Action>;
}>({
  state: initialState,
  dispatch: () => undefined,
});
